export enum ELocalStorageItems{
  ASK_FOR_ADDITIONAL_USER_DATA = 'askForAdditionalUserData',
}
